import React, { useState, useEffect } from "react";
import Navigation from "./navigation";
import useScrollToTop from "./useScrollToTop";
import { useParams, useNavigate, useLocation } from "react-router-dom"; // need for api call later
import NavInfoSubmissions from "./navInfoSubmissions";
import useWindowWidth from "./useWindowWidth";
import DeleteEvaluationForm from "./deleteEvaluationForm";
import NavInfoSubmissionsCollapsed from "./navInfoSubmissionsCollapsed";
import LeftInfoGradingPage from "./leftInfoGradingPage";
import LocationSettingsHover from "./locationSettingsHover";
import ZipFileViewerGradingPage from "./zipFileViewerGradingPage";
import TypesOfLocationEnum from "./typesOfLocationEnum";
import GradingPageCustomExamWrapper from "./gradingPageCustomExamWrapper";
import parseFileStructure from "./parseFileStructureToReturnPaths"
import parseZipFile from "./parseZipFile"
import fetchWithPreSigned from "./fetchWithPreSigned";
import fetchSubmissionPdf from "./fetchSubmissionPdf";
import findUuidsOfScanAndGrade from "./findUuidsOfScanAndGrade";
import retIgnoredPrefixes from "./retIgnorePrefixes";
import findStillProcessing from "./findStillProcessing";
import TypesOfQuestionsEnum from "./typesOfQuestionsEnum";
import ShowError from "./showError";
import gradeLambda from "./gradeLambda";
import gradeProgramming from "./gradeProgramming";
import LogViewer from "./logViewer";

const GradingPage = () => {
    useScrollToTop();
    const navigate = useNavigate();
    const width = useWindowWidth(1000);
    const { courseCode, assessmentCode, email } = useParams(); // need for api call later
    const [deleteEvaluation, setDeleteEvaluation] = useState(false);
    const [assessmentInformation, setAssessmentInformation] = useState({});
    const [isCursorInside, setIsCursorInside] = useState(false);
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const [contentsForViewer, setContentsForViewer] = useState([]);
    const [blob, setBlob] = useState();
    const [requestLifeCycleTwo, setRequestLifeCycleTwo] = useState(false);
    const [contentsForCustomExam, setContentsForCustomExam] = useState({});
    const [currentViewer, setCurrentViewer] = useState("");
    const [testsConfigDict, setTestsConfigDict] = useState({});
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    const [currentFilename, setCurrentFilename] = useState("");
    const [currentFileData, setCurrentFileData] = useState("");
    const [countsInformation, setCountsInformation] = useState({});
    const [pdfUrls, setPdfUrls] = useState({})
    const location = useLocation();
    const [requestLifeCycleThree, setRequestLifeCycleThree] = useState(false);
    const [error, setError] = useState(null);    
    const [ignoredPaths, setIgnoredPaths] = useState([]);
    const [ignoredPrefixes, setIgnoredPrefixes] = useState({});
    const [id, setId] = useState("");
    const [stillProcessing, setStillProcessing] = useState(false);
    const [mostRecentLastStartTime, setMostRecentLastStartTime] = useState(null);
    const [lastStartTime, setLastStartTime] = useState(null);
    const [status, setStatus] = useState(null);
    const [text, setText] = useState("Re-run all autograders");
    const [flip, setFlip] = useState(null);
    const [scrollAmount, setScrollAmount] = useState(0);
    const [logs, setLogs] = useState(null);

    function updateLogs(newLogs) {
        setLogs(newLogs);
    }

    function updateScrollAmount(newAmount) {
        setScrollAmount(newAmount);
    }

    function updateLastStartTime(newTime) {
        setLastStartTime(newTime);
    }

    function updateText(newText) {
        setText(newText);
    }

    function updateId(id) {
        setId(id);
    }

    function updatePdfUrls(pdfUrls) {
        setPdfUrls(pdfUrls);
    }

    function updateStatus(newStatus) {
        setStatus(newStatus)
    }

    const fetchStudentTests = async (loud = false) => {
        try {
            if (loud) {
                setRequestLifeCycleThree(true);
            }
            const response = await fetch( process.env.REACT_APP_SUBMISSION_API_URL + `/get-student-test-results/${courseCode}/${assessmentCode}/${email}?no_questions=${!loud}`, {
                method: "GET",
                credentials: "include"
            });
            const data = await response.json();
            if (response.status === 200) {
                if (loud || data.status !== 'RUNNING') {
                    if (data.OK) {
                        const testsConfigArray = JSON.parse(data.testsConfig);
                        const testsConfigToStore = testsConfigArray.tests.reduce((acc, curr) => {
                            acc[curr.id] = curr;
                            return acc;
                        }, {})
                        setTestsConfigDict(testsConfigToStore);
                        setError(null);
                        if (!loud) {
                            gradeProgramming(assessmentInformation?.gradedQuestions, testsConfigToStore, updateAssessmentInformation);
                        }
                    } else {
                        setError(data.error);
                        setTestsConfigDict({});
                    }
                }
                updateStatus(data.status);
                updateLastStartTime(data.lastStartTime);
            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else if (response.status !== 404) {
                setError("Status Code: " + response.status + " Error: " + data.detail);
                setTestsConfigDict({});
            }
    
        } catch (error) {
            setError("Error: " + error.message);
            setTestsConfigDict({});
            console.log(error);
        } finally {
            if (loud) {
                setRequestLifeCycleThree(false);
            }
        }
    }

    useEffect(() => {        
        fetchStudentTests(true);
    }, []);

    useEffect(() => {
        const iterateAndFetchPdfs = async () => {
            // initally set requestLifeCycle
            updatePdfUrls({
                requestLifeCycle: true
            })

            // returns a dict where key is uuid of scan and grade and value is null
            const questionsDict = findUuidsOfScanAndGrade(assessmentInformation.gradedQuestions);

            // handle the requests for the pdfs
            const dataPromises = Object.keys(questionsDict).map(async uuid => {
                try {
                    const [isOkay, pdfUrl] = await fetchSubmissionPdf(process.env.REACT_APP_SUBMISSION_API_URL + `/get-question-pdf/${courseCode}/${assessmentCode}/${email}/${uuid}`);
                    if (isOkay) {
                        questionsDict[uuid] = pdfUrl;
                    }
                } catch (error) {
                    console.error(error);
                    return null; // Handle errors gracefully
                }
            });

            await Promise.all(dataPromises);
            questionsDict.requestLifeCycle = false 
            updatePdfUrls(questionsDict);
        }

        if (assessmentInformation.gradedQuestions && assessmentInformation.gradedQuestions.length > 0) {
            iterateAndFetchPdfs()
        }

        return () => {
            Object.keys(pdfUrls).map((uuid) => {
                if (uuid && pdfUrls[uuid]) {
                    URL.revokeObjectURL(pdfUrls[uuid])
                }
            })
        }

    }, [assessmentInformation.gradedQuestions])

    useEffect(() => {
        const fetchSubmissionsAndGradedCount = async () => {
            try {
                const res = await fetch( process.env.REACT_APP_SUBMISSION_API_URL + `/get-submissions-and-graded-count/${courseCode}/${assessmentCode}`, {
                    method: "GET",
                    credentials: "include"
                });
                const data = await res.json();
                if (res.status === 200) {
                    setCountsInformation(data)
                } else if (res.status === 401) {
                    window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
                }
        
            } catch (error) {
                console.log(error);
            }
        }

        fetchSubmissionsAndGradedCount();
        
    }, []);

    function updateCurrentFilename(filename) {
        setCurrentFilename(filename);
    }

    function updateCurrentFileData(data) {
        setCurrentFileData(data);
    }

    function updateSetStillProcessing(newValue) {
        setStillProcessing(newValue);
    }
    
    useEffect(() => {
        const fetchTheme = async () => {
            try {
                const response = await fetch( process.env.REACT_APP_SUBMISSION_API_URL + `/get-theme`, {
                    method: "GET",
                    credentials: "include"
                });
                const data = await response.json();
                if (response.status === 200) {
                    setIsDarkTheme(data.isDarkTheme);
                } else if (response.status === 401) {
                    window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
                }
            } catch (error) {
                console.log(error);
            }
        };
        
        fetchTheme();
    }, [])

    function updateIsDarkTheme(theme) {
        setIsDarkTheme(theme);
        submitForm(theme);
    }

    function updateAssessmentInformation(newInfo) {
        setAssessmentInformation(newInfo);
    }

    function updateFeedbackAssessmentInformation(newFeedback) {
        setAssessmentInformation((prev) => {
            return {
                ...prev,
                feedback: newFeedback
            }
        })
    }

    const submitForm = async (theme) => {
        try {
            const url = process.env.REACT_APP_SUBMISSION_API_URL + "/update-theme";
            const urlOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    isDarkTheme: theme
                })
            }

            const response = await fetch(url, urlOptions);
            if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL
            }

        } catch(error) {
            console.log(error);
        }
    }

    const fetchAssessmentInformation = async (loud = false) => {
        if (!email) {
            return;
        }

        try {
            if (loud) {
                setRequestLifeCycle(true);
            }            
            const res = await fetch( process.env.REACT_APP_SUBMISSION_API_URL + `/get-submission-information/${courseCode}/${assessmentCode}/${email}`, {
                method: "GET",
                credentials: "include"
            });
            const data = await res.json();
            if (res.status === 200) {
                updateAssessmentInformation(data);
            } else if (res.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }
    
        } catch (error) {
            console.log(error);
        } finally {
            if (loud) {
                setRequestLifeCycle(false);
            }            
        }
    }

    useEffect(() => {
        const fetchZip = async () => {
            try {
                setRequestLifeCycleTwo(true)
                const res = await fetch( process.env.REACT_APP_SUBMISSION_API_URL + `/get-submission-zip/${courseCode}/${assessmentCode}/${email}`, {
                    method: "GET",
                    credentials: "include"
                });
                const data = await res.json()
                if (res.status === 200) {
                    const [status, blob] = await fetchWithPreSigned(data.url); // Get the ZIP as a blob
                    
                    if (status !== 200) {
                        return;
                    }
                    setBlob(blob)
                    const contents = await parseZipFile(blob);
                    setContentsForViewer(contents);
                    const parsedContents = parseFileStructure(contents)
                    setContentsForCustomExam(parsedContents)

                    // get ignore information
                    const testsConfig = "tests_config.json" in parsedContents ? JSON.parse(parsedContents["tests_config.json"].content) : {}
                    const ignoredPaths = testsConfig?.ignore.reduce((acc, path) => {
                        acc[path] = null;
                        return acc;
                    }, {})

                    setIgnoredPaths(ignoredPaths)
                    setIgnoredPrefixes(retIgnoredPrefixes(ignoredPaths))
                } else if (res.status === 401) {
                    window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
                }
            } catch (error) {
                console.log(error);
            } finally {
                setRequestLifeCycleTwo(false);
            }
        };
        
        if (assessmentInformation.zipFileExists && email) {
            fetchZip();
        }

    }, [assessmentInformation.zipFileExists, email])

    useEffect(() => {
        fetchAssessmentInformation(true);
    }, [])

    const handleDetailsClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${courseCode}/${assessmentCode}/settings`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${courseCode}/${assessmentCode}/settings`);
        }
    }

    const handleStatisticsClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${courseCode}/${assessmentCode}/statistics`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${courseCode}/${assessmentCode}/statistics`);
        }
    }

    const handleDashboardClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${courseCode}/${assessmentCode}/`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${courseCode}/${assessmentCode}/`);
        }
    }

    function updateDeleteEvaluation(deleteVal) {
        if (deleteVal) {
            // eslint-disable-next-line
            const didConfirm = confirm("Please note: evaluation deletion will delete all existing submissions and data associated. Are you sure you want to continue?");

            if (!didConfirm) {
                return;
            }
        } 

        setDeleteEvaluation(deleteVal);
    }

    const handleFocus = () => {
        setIsCursorInside(true);
    };
    
    const handleBlur = () => {
        setIsCursorInside(false);
    };

    function updateCurrentViewer(newViewer) {
        setCurrentViewer(newViewer);
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get("tab")
        const id = queryParams.get("id")

        if (tab) {
            setCurrentViewer(tab)
        } else {        
            setCurrentViewer(TypesOfLocationEnum.SETTINGS)
        }

        if (id) {
            updateId(id)
        }

    }, [location.search])

    useEffect(() => {     
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('id', id);
        const newSearch = searchParams.toString();

        navigate({
            pathname: location.pathname,
            search: newSearch,
        });
        
    }, [id, location.search])

    function currentViewerToReturn() {
        switch(currentViewer) {
            case TypesOfLocationEnum.ZIP: {
                return <ZipFileViewerGradingPage name={assessmentInformation.name} currentFilename={currentFilename} currentFileData={currentFileData} updateCurrentFilename={updateCurrentFilename} updateCurrentFileData={updateCurrentFileData} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} requestLifeCycle={requestLifeCycleTwo} blob={blob} contents={contentsForViewer}/>
            }
            case TypesOfLocationEnum.CUSTOM_EXAM: {
                return <GradingPageCustomExamWrapper scrollAmount={scrollAmount} updateScrollAmount={updateScrollAmount} updateAssessmentInformation={updateAssessmentInformation} status={status} endedExam={assessmentInformation.endedExam} error={error} testsConfigDict={testsConfigDict} id={id} updateId={updateId} ignoredPaths={ignoredPaths} ignoredPrefixes={ignoredPrefixes} requestLifeCycleTwo={requestLifeCycleTwo} requestLifeCycle={requestLifeCycle} updatePdfUrls={updatePdfUrls} pdfUrls={pdfUrls} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} updateCurrentViewer={updateCurrentViewer} contents={contentsForCustomExam} gradedQuestions={assessmentInformation.gradedQuestions}/>
            }
            case TypesOfLocationEnum.ERROR: {
                return <ShowError error={error} full={true}/>
            }
            case TypesOfLocationEnum.LOGS: {
                return <LogViewer name={assessmentInformation?.name?.replace(/ /g, "-").toLowerCase()} gradedQuestions={assessmentInformation.gradedQuestions} updateCurrentViewer={updateCurrentViewer} updateLogs={updateLogs} logs={logs} decodedEmail={assessmentInformation.decodedEmail}/>
            }
            default: {
                return <></>
            }
        }
    }

    const findIfLambdaExists = () => {
        return assessmentInformation?.gradedQuestions?.filter((question) => {
            return (
                (question?.questionType === TypesOfQuestionsEnum.LAMBDA && Object.keys(question?.testsMap).length > 0 && question.language !== "plaintext") ||
                (question?.questionType === TypesOfQuestionsEnum.SHORT_RESPONSE && question.useAi)
            )
        })?.length > 0
    }

    function updateGradedQuestions(newData, uuid) {        
        setAssessmentInformation((prev) => {
            return {
                ...prev,
                gradedQuestions: prev.gradedQuestions.map((question) => {
                    if (question.uuid !== uuid) return {...question};

                    if (newData.status === 'COMPLETED') {
                        return {
                            ...question,
                            status: newData.status,
                            attempt: newData.attempt,
                            lastStartTime: newData.lastStartTime,
                            results: newData.results,
                            pointsEarned: gradeLambda(question, newData.results, question.questionType)
                        }
                    } else if (newData.status === 'FETCH_ERROR') {
                        return {
                            ...question,
                            status: newData.status,
                            results: newData.results
                        }
                    }

                    return {
                        ...question,
                        lastStartTime: newData.lastStartTime,
                    }
                })
            }
        })
    }

    const findQuestion = async (uuid) => {
        try {
            const url = process.env.REACT_APP_EVALUATION_API_URL + `/fetch-lambda-results/${courseCode}/${assessmentCode}/${uuid}?email=${email}&student_results=${true}&no_questions=${true}`
            const urlOptions = {
                method: "GET",
                credentials: "include",                
            }
            
            const response = await fetch(url, urlOptions);
            const data = await response.json();
            if (response.status === 200) {
                updateGradedQuestions(data, uuid);
            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL
            } else {
                updateGradedQuestions({
                    status: "FETCH_ERROR",
                    results: "Status Code: " + response.status + " Error: " + data.detail
                }, uuid);
            }

        } catch (error) {
            console.log(error);
            updateGradedQuestions({
                status: "FETCH_ERROR",
                results: "Error: " + error.message
            }, uuid);
        }
    }

    useEffect(() => {
        // get initial run state    
        const [stillOngoing, currentMostRecentLastStartTime] = findStillProcessing(assessmentInformation.gradedQuestions, status, lastStartTime)
        setStillProcessing(stillOngoing.questions || stillOngoing.tests);
        setMostRecentLastStartTime(currentMostRecentLastStartTime);
        
        // start an interval and see if 
        const timer = setInterval(async () => {
            const fifteenMinutes = 15 * 60 * 1000;
            const hasBeenFifteenMinutes = !!(((new Date().getTime()) - (new Date(currentMostRecentLastStartTime).getTime())) >= fifteenMinutes);

            if (!hasBeenFifteenMinutes) {
                if (stillOngoing.questions && stillOngoing.tests) {
                    for (let i = 0; i < stillOngoing.uuids.length; i++) {
                        findQuestion(stillOngoing.uuids[i]);
                    }
                    fetchStudentTests();
                } else if (stillOngoing.questions) {
                    for (let i = 0; i < stillOngoing.uuids.length; i++) {
                        findQuestion(stillOngoing.uuids[i]);
                    }
                } else if (stillOngoing.tests) {
                    fetchStudentTests();
                }
            }

            setFlip(prev => !prev);
            
        }, 5000)

        setFlip(prev => !prev);

        return () => {
            clearInterval(timer);
        }

    }, [status, assessmentInformation.gradedQuestions, lastStartTime])

    const findMessage = () => {
        return "Re-run all autograders"
    }

    useEffect(() => {
        let timer = null;

        if (text === "Success" || text === "Failed") {
            timer = setTimeout(() => {
                setText(findMessage());
            }, 3000);
        } else {
            setText(findMessage());
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }

    }, [assessmentInformation, assessmentInformation.gradedQuestions, assessmentInformation.zipFileExists])

    return (
        <>
            <Navigation currentViewer={currentViewer} id={id} isCursorInside={isCursorInside} boolFive={true} bool={false} info={ <NavInfoSubmissions showAggregation={assessmentInformation.showAggregation} isProgramming={assessmentInformation.isProgramming} updateDeleteEvaluation={updateDeleteEvaluation} handleDashboardClick={handleDashboardClick} handleStatisticsClick={handleStatisticsClick} handleDetailsClick={handleDetailsClick} name={assessmentInformation.evalName} description={"assessment settings. You may change assessment settings up to 30 minutes before the scheduled start time."} title={"Manage Settings"}/> } infoCollapsed={ <NavInfoSubmissionsCollapsed handleDashboardClick={handleDashboardClick} updateDeleteEvaluation={updateDeleteEvaluation} handleStatisticsClick={handleStatisticsClick} handleDetailsClick={handleDetailsClick}/>}/>
            <div className="courses-container" style={{ position: width ? "relative" : "fixed" }}>
                <div className={`single-course-container viewer full ${width ? "small" : "height"}`}>
                    <div className={`assessment-page-content min ${width ? "small" : ""}`}>
                        {
                            currentViewer === TypesOfLocationEnum.SETTINGS

                            ?                    

                            <>
                                <LeftInfoGradingPage scrollAmount={scrollAmount} updateScrollAmount={updateScrollAmount} updateFeedbackAssessmentInformation={updateFeedbackAssessmentInformation} updateLastStartTime={updateLastStartTime} flip={flip} mostRecentLastStartTime={mostRecentLastStartTime}  findIfLambdaExists={findIfLambdaExists} text={text} updateText={updateText} updateAssessmentInformation={updateAssessmentInformation} updateStatus={updateStatus} updateSetStillProcessing={updateSetStillProcessing} status={status} stillProcessing={stillProcessing} endedExam={assessmentInformation.endedExam} error={error} testsConfigDict={testsConfigDict} id={id} updateId={updateId} ignoredPaths={ignoredPaths} ignoredPrefixes={ignoredPrefixes} requestLifeCycleTwo={requestLifeCycleTwo || requestLifeCycleThree} updatePdfUrls={updatePdfUrls} pdfUrls={pdfUrls} countsInformation={countsInformation} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} contents={contentsForCustomExam} updateCurrentViewer={updateCurrentViewer} requestLifeCycle={requestLifeCycle} assessmentInformation={assessmentInformation} isCursorInside={isCursorInside} handleBlur={handleBlur} handleFocus={handleFocus}/>
                            </>

                            :
                            
                            <>
                            </>

                        }
                        {
                            currentViewerToReturn()
                        }
                    </div>
                </div>
            </div>
            <LocationSettingsHover useLogging={assessmentInformation.useLogging} errorExists={error} grading={true} pdfExists={false} zipFileExists={assessmentInformation.zipFileExists} updateCurrentViewer={updateCurrentViewer} isProgramming={assessmentInformation.isProgramming}/>
            { deleteEvaluation ? <DeleteEvaluationForm name={assessmentInformation.name} updateDeleteEvaluation={updateDeleteEvaluation} /> : <></> }
        </>
    );
}

export default GradingPage;